<template>
  <div class="relative flex flex-wrap px-4 pt-10 pb-10 sm:px-6 lg:px-32">
    <div class="w-full lg:w-1/4">
      <div class="pb-6 bg-gray-type-4">
        <div
          class="
            flex flex-col
            items-center
            justify-center
            w-full
            h-40
            py-2
            px-4
            rounded rounded-t rounded-b-none rounded-l-none rounded-r-none
            bg-dark-type-1
          "
        >
          <template v-if="loadingWallet">
            <div class="my-40 spinner"></div>
          </template>
          <template v-else>
            <template v-if="wallet && Object.keys(wallet).length">

              <div class="mt-2 text-3xl font-bold leading-7 text-white text-center">
                &#8358; {{ wallet.amount | currency }}
              </div>
              <div class="mt-1  text-xs font-medium text-white uppercase">
                Wallet Balance
              </div>

              <div class="mt-6 text-xs w-full font-medium text-white flex justify-between">
                <span>Personal</span>
                <span>&#8358; {{(wallet.main_balance || 0) | currency}}</span>
              </div>

              <div v-if="user && user.corporate_id" class="mt-2 text-xs w-full font-medium text-white flex justify-between">
                <span>Corporate</span>
                <span>&#8358; {{wallet.credit_amount | currency}}</span>
              </div>

            </template>
          </template>
        </div>
        <div class="flex items-center px-4 mt-6">
          <div>
            <svg
              class="w-4 h-4 fill-current text-dark-type-3"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 20 20"
            >
              <path
                d="M18 6V4H2v2h16zm0 4H2v6h16v-6zM0 4c0-1.1.9-2 2-2h16a2 2 0 012 2v12a2 2 0 01-2 2H2a2 2 0 01-2-2V4zm4 8h4v2H4v-2z"
              />
            </svg>
          </div>
          <div class="ml-2 text-sm font-bold text-dark-type-3">
            Fund with debit/credit card
          </div>
        </div>
        <div
          class="inline-flex items-center px-4 mt-2 font-medium text-xxs"
          v-if="!isIframeApp()"
        >
          <span>Your transactions are secured by</span>
          <svg
            class="ml-1"
            xmlns="http://www.w3.org/2000/svg"
            width="58"
            height="12"
          >
            <g fill="none">
              <path
                fill="#0BA4DB"
                d="M9.565 0H.555A.557.557 0 000 .556v1c0 .305.25.555.555.555h8.983c.305 0 .554-.25.554-.555v-1A.517.517 0 009.565 0zm0 5.583H.555A.557.557 0 000 6.139v1c0 .305.25.555.555.555h8.983c.305 0 .554-.25.554-.555v-1a.517.517 0 00-.527-.556zM5.628 8.39H.555A.557.557 0 000 8.945v1c0 .306.25.556.555.556h5.073c.305 0 .555-.25.555-.556v-1a.557.557 0 00-.555-.555zm4.492-5.583H.555A.557.557 0 000 3.362v1c0 .306.25.556.555.556h9.565c.305 0 .554-.25.554-.556v-1a.557.557 0 00-.554-.555z"
              />
              <path
                fill="#131615"
                d="M15.846 9.398a.236.236 0 00.244-.242V7.12h1.424c.709 0 1.29-.229 1.744-.686.455-.457.691-1.037.71-1.74 0-.696-.229-1.277-.688-1.744-.46-.467-1.048-.7-1.766-.7h-3.011c-.07 0-.13.025-.18.074a.245.245 0 00-.073.178v6.654c0 .07.024.127.071.173.048.046.108.07.182.07h1.343zm.274-3.904v-1.65h1.096c.241 0 .44.078.595.233a.8.8 0 01.233.59c0 .235-.078.43-.233.587a.816.816 0 01-.595.24H16.12zm6.515 4.07c.243 0 .468-.04.676-.12.207-.078.392-.197.557-.355v.086c0 .066.024.123.073.17a.24.24 0 00.173.071H25.4a.22.22 0 00.163-.07.239.239 0 00.069-.171V4.608a.23.23 0 00-.066-.17.235.235 0 00-.171-.066h-1.29a.227.227 0 00-.237.236v.09a1.696 1.696 0 00-.557-.35 1.887 1.887 0 00-.676-.119c-.721 0-1.327.258-1.819.773-.492.514-.738 1.146-.738 1.894 0 .749.246 1.38.738 1.895a2.415 2.415 0 001.819.772zm.275-1.65a.964.964 0 01-.721-.306 1.024 1.024 0 01-.296-.74c0-.289.099-.535.296-.739.197-.203.437-.305.721-.305s.525.102.722.305c.197.204.295.45.295.74s-.098.536-.295.74a.969.969 0 01-.722.305zm4.683 3.959c.56 0 1.037-.148 1.433-.444.396-.295.678-.714.847-1.258l1.669-5.431c.038-.13.038-.23 0-.298-.038-.068-.113-.103-.224-.103H29.93a.288.288 0 00-.186.062.347.347 0 00-.11.181l-.658 2.693-.777-2.702a.38.38 0 00-.103-.179.261.261 0 00-.174-.055h-1.478c-.13 0-.22.036-.267.108-.048.071-.05.169-.005.293l1.54 4.43a.38.38 0 00.12.177.281.281 0 00.185.067h.296l-.19.486a.706.706 0 01-.249.338.66.66 0 01-.39.115.821.821 0 01-.275-.048 1.797 1.797 0 01-.34-.176.386.386 0 00-.28-.065.361.361 0 00-.231.17l-.434.657a.383.383 0 00-.072.231.301.301 0 00.09.203c.21.171.46.305.747.402.288.097.59.146.904.146zm6.563-2.31c.724 0 1.299-.158 1.725-.474.425-.315.638-.739.638-1.269 0-.404-.128-.737-.383-1-.256-.262-.629-.445-1.118-.549l-.967-.208a.556.556 0 01-.238-.095.189.189 0 01-.077-.152c0-.07.043-.126.13-.17a.7.7 0 01.323-.067c.156 0 .323.029.503.086.18.057.372.142.579.256.12.066.225.097.312.092a.362.362 0 00.245-.13l.472-.507c.086-.098.126-.19.122-.275-.005-.085-.054-.166-.146-.242-.2-.18-.495-.33-.886-.45a4.21 4.21 0 00-1.244-.18c-.648 0-1.178.163-1.589.488-.411.326-.617.733-.617 1.222 0 .392.122.72.367.983.244.264.588.44 1.03.528l.947.195a.866.866 0 01.327.118c.071.05.107.114.107.19 0 .075-.043.138-.129.187a.697.697 0 01-.347.073 1.63 1.63 0 01-.589-.118c-.202-.08-.4-.191-.593-.337-.124-.094-.227-.142-.31-.142a.42.42 0 00-.262.114l-.524.426c-.156.127-.207.27-.153.429.054.16.21.32.467.48.248.155.538.277.87.365.332.089.668.133 1.008.133zm5.117-.055c.334 0 .65-.052.947-.157.297-.104.536-.248.717-.432a.285.285 0 00.09-.199.376.376 0 00-.07-.228l-.449-.67c-.06-.085-.125-.135-.193-.151-.065-.015-.143.002-.234.052l-.016.01a1.68 1.68 0 01-.263.125.638.638 0 01-.214.04.355.355 0 01-.272-.106.41.41 0 01-.1-.292V5.814h1.116a.24.24 0 00.243-.247V4.59a.224.224 0 00-.072-.168.237.237 0 00-.171-.069h-1.116v-1.04a.226.226 0 00-.07-.168.228.228 0 00-.168-.07h-1.424a.111.111 0 00-.11.103v.009l.003.483c.002.371 0 .595-.005.67h-.703c-.048.054-.054.614-.055.81v.418c0 .07.023.129.07.176.045.048.1.071.164.071h.524V7.87c0 .513.166.914.499 1.204.332.29.776.434 1.332.434zm4.476.055c.244 0 .469-.04.676-.118.207-.08.393-.198.557-.356v.086c0 .066.025.123.074.17a.239.239 0 00.173.071h1.285a.239.239 0 00.233-.241V4.608a.231.231 0 00-.067-.17.23.23 0 00-.17-.066h-1.29a.228.228 0 00-.238.236v.09a1.686 1.686 0 00-.557-.35 1.88 1.88 0 00-.676-.119c-.72 0-1.327.258-1.819.773-.491.514-.737 1.146-.737 1.894 0 .749.246 1.38.737 1.895a2.416 2.416 0 001.82.772zm.276-1.65a.965.965 0 01-.722-.305 1.023 1.023 0 01-.295-.74c0-.289.098-.535.295-.739.197-.203.438-.305.722-.305s.524.102.721.305c.197.204.296.45.296.74s-.099.536-.296.74a.966.966 0 01-.721.305zm6.076 1.65c.565 0 1.064-.124 1.495-.372a2.19 2.19 0 00.939-1.025.315.315 0 00.016-.273c-.036-.083-.115-.143-.235-.177l-.967-.29a.513.513 0 00-.24-.023c-.066.013-.147.074-.246.185a.888.888 0 01-.333.258c-.13.058-.273.088-.429.088a.984.984 0 01-.728-.304c-.2-.202-.3-.446-.3-.734 0-.287.1-.532.3-.734a.987.987 0 01.728-.303c.156 0 .299.03.429.088.13.058.241.144.333.258.095.11.176.172.243.184a.523.523 0 00.243-.023l.967-.29c.12-.034.199-.093.235-.177.037-.083.031-.174-.016-.272a2.188 2.188 0 00-.939-1.026c-.431-.248-.93-.372-1.495-.372-.78 0-1.443.26-1.988.777-.544.518-.817 1.148-.817 1.89s.273 1.372.817 1.89c.545.518 1.207.777 1.988.777zm4.451-.165a.228.228 0 00.167-.066.228.228 0 00.066-.166V7.158l1.29 2.088c.035.054.08.093.134.117a.644.644 0 00.242.035h1.257c.146 0 .241-.041.285-.123.045-.083.03-.18-.042-.295l-1.543-2.396 1.267-1.833c.066-.098.084-.19.052-.277-.032-.087-.106-.13-.224-.13h-1.237a.355.355 0 00-.184.049.455.455 0 00-.145.145l-1.152 1.784V2.487a.229.229 0 00-.066-.17.231.231 0 00-.171-.067h-1.295a.231.231 0 00-.171.066.231.231 0 00-.067.171v6.679a.22.22 0 00.071.166.252.252 0 00.176.066h1.29z"
              />
            </g>
          </svg>
        </div>
        <form class="px-4 mt-6" @submit.prevent="fundWallet">
          <div>
            <label class="text-xs font-medium" for="amount"
              >Enter funding amount</label
            >
            <div class="relative mt-2">
              <currency-input
                v-model="form.amount"
                class="
                  w-full
                  h-12
                  px-3
                  py-4
                  pl-6
                  text-xs
                  font-medium
                  bg-white
                  outline-none
                  placeholder-label-type-1
                  focus:outline-none
                "
              />
              <div
                class="
                  absolute
                  inset-y-0
                  left-0
                  flex
                  items-center
                  pl-2
                  mt-1
                  text-xs
                  font-medium
                  cursor-pointer
                  text-dark-type-3
                "
              >
                &#8358;
              </div>
            </div>
          </div>
          <button
            type="submit"
            class="
              block
              w-full
              py-2 py-4
              mt-4
              font-bold
              text-center text-white
              rounded
              focus:outline-none
            "
            :class="amountValid ? 'bg-active' : 'bg-gray-type-7'"
            :disabled="!amountValid"
          >
            Fund wallet
          </button>
        </form>
      </div>
      <div
        class="px-4 py-6 mt-2 bg-gray-type-4"
        v-if="wallet && wallet.accountNumbers"
      >
        <div class="flex">
          <div>
            <svg
              class="w-4 h-4 fill-current text-dark-type-3"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 20 20"
            >
              <path
                d="M18 6V4H2v2h16zm0 4H2v6h16v-6zM0 4c0-1.1.9-2 2-2h16a2 2 0 012 2v12a2 2 0 01-2 2H2a2 2 0 01-2-2V4zm4 8h4v2H4v-2z"
              />
            </svg>
          </div>
          <div class="ml-2 text-sm font-bold text-dark-type-3">
            Fund with Bank Transfer/Deposit
          </div>
        </div>
        <div class="mt-4 font-medium text-xxs text-dark-type-4">
          <p>
            Make a transfer to the account details below to fund your wallet.
          </p>
        </div>
        <div class="mt-4">
          <div class="inline-flex items-center">
            <div class="text-xs font-medium text-dark-type-4">Bank:</div>
            <div class="ml-2 text-xs font-bold text-dark-type-3">
              {{ wallet.accountNumbers[0].bank_name }}
            </div>
          </div>
          <div class="inline-flex items-center mt-2">
            <div class="text-xs font-medium text-dark-type-4">
              Account number:
            </div>
            <div class="ml-2 text-xs font-bold text-dark-type-3">
              {{ wallet.accountNumbers[0].account_number }}
            </div>
          </div>
        </div>

        <div class="mt-4 font-medium text-xxs text-dark-type-4">
          <p>
            Your wallet will be automatically funded once payment is received.
            Funding of account via bank transfer takes 5 - 10 minutes.
          </p>
        </div>
      </div>
    </div>
    <div class="self-stretch flex-1 px-4 py-6 rounded bg-gray-type-4 lg:ml-8">
      <template v-if="loadingWallet">
        <div class="flex items-center justify-center h-full">
          <div class="spinner"></div>
        </div>
      </template>
      <template v-else>
        <template v-if="walletHistory && walletHistory.length > 0">
          <div class="text-xl font-bold text-dark-type-3">
            Transaction history
          </div>
          <div class="mt-6">
            <div
              @click="showTransactionDetails(item)"
              class="
                flex
                justify-between
                px-4
                py-5
                bg-white
                rounded
                cursor-pointer
                even:bg-gray-type-6
              "
              v-for="item in walletHistory"
              :key="item.id"
            >
              <div class="flex items-center mr-4">
                <div>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="32"
                    height="32"
                  >
                    <g fill="none" fill-rule="evenodd">
                      <path
                        fill="#F3F7F5"
                        d="M4 0h24c2.21 0 4 1.79 4 4v24c0 2.21-1.79 4-4 4H4c-2.21 0-4-1.79-4-4V4c0-2.21 1.79-4 4-4z"
                      />
                      <g fill="#ABBAB5" fill-rule="nonzero">
                        <path
                          d="M9.62 15.129v-1.944a.323.323 0 100-.648c-.893 0-1.62.727-1.62 1.62v.648c0 .536.436.972.972.972h.648a.323.323 0 100-.648zm12.314-2.592a.324.324 0 100 .648v1.944a.324.324 0 100 .648h.648a.973.973 0 00.972-.972v-.648c0-.893-.726-1.62-1.62-1.62zm-8.425 9.073a.323.323 0 00-.324.324H11.24a.324.324 0 10-.648 0v.648c0 .536.436.972.972.972h1.297a.973.973 0 00.972-.972v-.648a.324.324 0 00-.324-.324zm7.129 0a.323.323 0 00-.324.324h-1.945a.324.324 0 10-.648 0v.648c0 .536.436.972.972.972h1.297a.973.973 0 00.972-.972v-.648a.324.324 0 00-.324-.324z"
                        />
                        <path
                          d="M20.638 8h-9.722c-.893 0-1.62.727-1.62 1.62v11.018c0 .893.727 1.62 1.62 1.62h9.722c.893 0 1.62-.727 1.62-1.62V9.62c0-.893-.727-1.62-1.62-1.62zm-8.425 1.296h7.129a.973.973 0 010 1.944h-7.13c-.535 0-.972-.436-.972-.972s.437-.972.973-.972zm0 11.018c-.536 0-.973-.436-.973-.972s.437-.973.973-.973.972.437.972.973-.436.972-.972.972zm7.129 0c-.536 0-.973-.436-.973-.972s.437-.973.973-.973.972.437.972.973-.436.972-.972.972zm1.62-4.213a.973.973 0 01-.972.972h-8.426a.974.974 0 01-.972-.972v-3.24c0-.536.437-.972.972-.972h8.426c.536 0 .972.436.972.972V16.1z"
                        />
                      </g>
                    </g>
                  </svg>
                </div>
                <div class="ml-4">
                  <div>
                    <div
                      class="text-xs font-bold leading-relaxed text-dark-type-3"
                    >
                      {{ item.title }}
                    </div>
                    <div class="font-medium text-xxs text-dark-type-4">
                      {{ item.created_at | date("D MMMM, YYYY") }}
                    </div>
                  </div>
                </div>
              </div>
              <div class="flex-shrink-0">
                <div
                  class="text-sm font-bold text-red-type-1"
                  v-if="item.type === 'debit'"
                >
                  &#8358; {{ item.amount | currency }}
                </div>
                <div
                  class="text-sm font-bold text-active"
                  v-if="item.type === 'credit'"
                >
                  &#8358; {{ item.amount | currency }}
                </div>
              </div>
            </div>
          </div>
        </template>
        <template v-else>
          <div class="flex flex-col items-center justify-center lg:py-20">
            <img
              src="@/assets/img/something-went-wrong.svg"
              alt="No transactions"
            />
            <div class="mt-10 text-2xl font-bold text-dark-type-3">
              No wallet history
            </div>
            <div class="mt-4 text-xs font-medium text-dark-type-4">
              Shuttles rides can be paid for by funding your wallet
            </div>
            <router-link
              :to="{ name: 'dashboard.home' }"
              class="
                block
                w-56
                py-2 py-4
                mt-10
                font-bold
                text-center text-white
                rounded
                bg-active
              "
              >Book a shuttle</router-link
            >
          </div>
        </template>
      </template>
    </div>
    <div class="absolute top-0 bottom-0 right-0 w-1/4">
      <div class="h-full px-6 py-6 bg-white shadow-type-1" v-if="showDetails">
        <div class="cursor-pointer" @click="showDetails = false">
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24">
            <g fill="none" fill-rule="evenodd">
              <circle cx="12" cy="12" r="12" fill="#FCFCFC" />
              <path
                d="M16 8l-8 8m0-8l8 8"
                stroke="#131615"
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="1.5"
              />
            </g>
          </svg>
        </div>
        <div class="mt-10 font-bold text-dark-type-3">
          {{ selectedHistoryItem.title }}
        </div>
        <div class="mt-1 text-xs font-medium text-dark-type-4">
          {{ selectedHistoryItem.created_at | date("D MMMM, YYYY") }}
        </div>
        <div class="mt-8">
          <div class="flex items-center justify-between mt-4">
            <div class="text-xs font-medium text-dark-type-4">Type</div>
            <div class="text-xs font-medium text-dark-type-3">
              {{ selectedHistoryItem.type | uppercase }}
            </div>
          </div>

          <div class="flex items-center justify-between mt-4">
            <div class="text-xs font-medium text-dark-type-3">Amount</div>
            <div class="text-xs font-bold text-dark-type-3">
              &#8358; {{ selectedHistoryItem.amount | currency }}
            </div>
          </div>
          <div class="flex items-center justify-between mt-4">
            <div class="text-xs font-medium text-dark-type-3">Wallet</div>
            <div class="text-xs font-medium text-dark-type-3">
               {{ selectedHistoryItem.payment_source | walletType }}
            </div>
          </div>
          <div class="flex items-center justify-between mt-4">
            <div class="text-xs font-medium text-dark-type-3">Previous Balance</div>
            <div class="text-xs font-medium text-dark-type-3">
              &#8358; {{ selectedHistoryItem.balance_before | currency }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { isIframeApp } from "@/services/utils";
import CurrencyInput from "@/components/CurrencyInput";
import paymentProcessor from "@/mixins/payment-processor";

export default {
  components: {
    CurrencyInput,
  },
  data() {
    return {
      showDetails: false,
      selectedHistoryItem: null,
      loadingWallet: false,
      form: {
        amount: "",
      },
    };
  },
  mixins: [paymentProcessor],
  created() {
    if (!Object.keys(this.wallet).length || !this.walletHistory) {
      this.loadingWallet = true;

      this.$store
        .dispatch("app/fetchWallet")
        .finally(() => (this.loadingWallet = false));
    }
  },
  computed: {
    ...mapGetters("app", ["wallet", "walletHistory"]),
    ...mapGetters("auth", ["user"]),
    normalizedAmount() {
      return this.$options.filters.normalizeCurrency(this.form.amount);
    },
    amountValid() {
      return this.normalizedAmount >= 100;
    },
  },
  methods: {
    fundWallet() {
      if (isIframeApp()) {
        return this.payWithQT();
      }

      this.pay({
        amount: this.normalizedAmount,
        user_id: this.wallet.user_id,
        customer_email: this.user.email,
        custom_fields: [
          {
            display_name: "Wallet ID",
            variable_name: "wallet_id",
            value: this.wallet.id,
          },
        ],
      })
        .then((res) => {
          if (res) {
            this.$toast.success("Your payment has been made successfully.");

            this.$store.dispatch("app/fetchWallet");

            this.form.amount = "";
          }
        })
        .catch((e) => {
          console.error(e);
          this.$toast.error("Unable to process payment, please try again.");
        });
    },
    payWithQT() {
      window.qtSdk.payWithQt({
        serviceName: "samsung",
        customerId: "2345678",
        itemName: "Laptop",
      });
    },
    showTransactionDetails(item) {
      this.selectedHistoryItem = item;
      console.log(item);

      this.showDetails = true;
    },
    isIframeApp: isIframeApp,
  },
};
</script>
